import Head from "next/head";
import { PropsWithChildren } from "react";

export interface PlatformsThemeProviderProps extends PropsWithChildren {
  settings: any;
}

export function EditorThemeProvider({
  children,
  settings,
}: PlatformsThemeProviderProps): JSX.Element {
  const sansFont = settings?.theme?.fontFamily?.sans[0] ?? "Roboto";
  const serifFont = settings?.theme?.fontFamily?.serif[0] ?? "Roboto";

  const rootStyle = `
    :root {
      --font-sans: ${sansFont.replace(/_/g, " ")};
      --font-serif: ${serifFont.replace(/_/g, " ")};
    }
  `;

  return (
    <div>
      <Head>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link
          rel="preconnect"
          href="https://fonts.gstatic.com"
          crossOrigin="anonymous"
        />
        <link
          href={`https://fonts.googleapis.com/css2?family=\${sansFont.replace(
            /_/g,
            "+"
          )}:wght@400;500;600;700;800;900&display=swap`}
          rel="stylesheet"
        />
        <link
          href={`https://fonts.googleapis.com/css2?family=\${serifFont.replace(
            /_/g,
            "+"
          )}:wght@400;500;600;700;800;900&display=swap`}
          rel="stylesheet"
        />
        <style>{rootStyle}</style>
      </Head>
      {children}
    </div>
  );
}
